import type { ReactElement } from 'react';

/** Desktop Blog link and its compact mobile navigation-menu counterpart. */
export function BlogNav(): ReactElement {
  return (
    <>
      <a href="/blog" className="ember-nav-blog" data-log="nav_blog">
        Blog
      </a>
      <details className="ember-nav-mobile-menu">
        <summary className="ember-nav-icon ember-nav-mobile-trigger" aria-label="Open navigation menu" data-log="nav_menu">
          <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
            <path d="M5 7h14M5 12h14M5 17h14" />
          </svg>
        </summary>
        <div className="ember-nav-menu ember-nav-site-menu-panel" role="menu">
          <a href="/blog" className="ember-nav-menu-item" role="menuitem" data-log="nav_blog">
            Blog
          </a>
        </div>
      </details>
    </>
  );
}
